export default __webpack_public_path__ + "static/media/WELLNESS.7105f759.png";